import { useEffect, useState } from "react";
import useStyles from "../../assets/styles/styles";
import { Fragment } from "react";
import {
    Grid,
    Box,
    Typography,
    IconButton,
    List,
    ListItem,
    Divider,
    Accordion,
    AccordionSummary,
    AccordionDetails,
    Tab, Tabs,
} from "@material-ui/core";
import AccountBoxIcon from '@mui/icons-material/AccountBox';
import MenuBookIcon from '@mui/icons-material/MenuBook';
import WarningIcon from '@material-ui/icons/Warning';
import MenuProfile from "../Menu/MenuProfile";
import { useHistory, useLocation } from "react-router";
import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import "../AskTurn/SelectDateDrawer/doctorCalendarAgenda.css";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import Header from "../GenericHeader/Header";
import NotFound from "../HomeLogged/NotFound";
import CustomButton from "../../controls/Button/CustomButton";
import AddCircleIcon from "@material-ui/icons/AddCircle";
import { useDispatch, useSelector } from "react-redux";
import { getEvolutionsDetailAction, getEvolutionsDetailByAction } from "../../redux/actions/appointmentsActions";
import { showErrorMessageModal } from "../../utils/utilsFunctions";
import DetailEvolution from "./DetailEvolution";
import ModalEvolution from "../DialogEvolution/ModalEvolution";
import TabPanel from "../../controls/TabPanel/TabPanel";
import SwipeableViews from "react-swipeable-views";
import { useTheme } from '@material-ui/core/styles';
import TabEvolution from "./TabsMedicalHistory/TabEvolution";
import TabLaboratorio from "./TabsMedicalHistory/TabLaboratorio";
import DetailLaboratory from "./DetailMedicalHistory/DetailLaboratory";
import TabSignosVitales from "./TabsMedicalHistory/TabSignosVitales";
import DetailVitalSigns from "./DetailMedicalHistory/DetailVitalSigns";
import TabAnthropometry from "./TabsMedicalHistory/TabAnthropometry";
import DetailAnthropometry from "./DetailMedicalHistory/DetailAnthropometry";


const MedicalHistory = () => {
    const classes = useStyles();
    const history = useHistory();
    const location = useLocation();
    const dispatch = useDispatch();
    const { especialidad } = location.state || {};
    const [loading] = useState();
    const [isLoading] = useState(false);
    const [selectedSpecialty, setSelectedSpecialty] = useState(especialidad || '');
    const [specialtiesByDoctor, setSpecialtiesByDoctor] = useState([]);
    const [visibleItems, setVisibleItems] = useState(10);
    const [loadingMore, setLoadingMore] = useState(false);
    const modelEvolutionsReducer = useSelector(state => state.appointmentsReducer);
    const modelEvolutions = modelEvolutionsReducer?.evolutions;
    const modelLaboratoryReducer = useSelector(state => state.appointmentsReducer);
    const modelLaboratory = modelLaboratoryReducer?.laboratory;
    const modelVitalSignsReducer = useSelector(state => state.appointmentsReducer);
    const modelVitalSigns = modelVitalSignsReducer?.vitalSigns;
    const modelAnthropometryReducer = useSelector(state => state.appointmentsReducer);
    const modelAnthropometry = modelAnthropometryReducer?.anthropometry;
    const { msgError } = useSelector(state => state.appointmentsReducer);
    const [openModalError, setOpenModalError] = useState(false);
    const [isInitialLoad, setIsInitialLoad] = useState(true);
    const [openDetailModal, setOpenDetailModal] = useState(false);
    const [selectedEvolution, setSelectedEvolution] = useState(null);
    const modelEvolutionsByReducer = useSelector(state => state.appointmentsReducer);
    const modelByEvolutions = modelEvolutionsByReducer?.evolutionsByDetail?.[0];
    const { selectedPatient, codeMedicalCenters, medicalCenters, codeSpecialty, agendaMedical, selectedDay, closestTurn, lastTurnOfDay, centro, businessHours } = location.state || {};
    const [value, setValue] = useState(0);
    const theme = useTheme();





    const mockPatientData = {
        datosAfiliado: {
            nombre: "Juan Pérez",
            dni: "30123456",
            credencial: {
                plan: "Plan 210",
                numero: "987654321"
            },
            fechaNacimiento: null,
            sexo: "Masculino"
        },
        enrolamientos: [
            {
                programa: "Programa de Diabetes",
                fechaDesde: "2023-01-01",
                fechaBaja: null
            },
            {
                programa: "Programa Cardiovascular",
                fechaDesde: "2023-03-15",
                fechaBaja: "2023-12-31"
            }
        ],
        alertas: [
            {
                tipo: "Alergia",
                observacion: "Alérgico a la penicilina"
            },
        ]
    };


    useEffect(() => {
        dispatch(getEvolutionsDetailAction());
    }, []);


    useEffect(() => {
        if (openDetailModal) {
            dispatch(getEvolutionsDetailByAction());
        }
    }, [openDetailModal, value]);


    useEffect(() => {
        if (msgError !== "" && msgError !== undefined) {
            setOpenModalError(true);
        }

    }, [msgError])


    useEffect(() => {
        const uniqueSpecialties = ["TODAS", ...new Set(modelEvolutions.map(item => item.especialidad))];
        setSpecialtiesByDoctor(uniqueSpecialties);

        if (especialidad && !uniqueSpecialties.includes(especialidad)) {
            setSpecialtiesByDoctor([...uniqueSpecialties, especialidad]);
        }
    }, [especialidad, modelEvolutions]);


    useEffect(() => {
        const handleScroll = () => {
            const scrolledToBottom =
                window.innerHeight + window.pageYOffset >=
                document.documentElement.scrollHeight - 100;

            if (scrolledToBottom && !loadingMore) {
                setLoadingMore(true);
                setTimeout(() => {
                    setVisibleItems(prev => prev + 10);
                    setLoadingMore(false);
                }, 1000);
            }
        };

        window.addEventListener('scroll', handleScroll);
        return () => window.removeEventListener('scroll', handleScroll);
    }, [visibleItems, loadingMore]);





    const handleClickSeeMore = (item) => (e) => {
        e.preventDefault();
        setSelectedEvolution(item);
        setOpenDetailModal(true);
    };


    const handleChangeIndex = (index) => {
        setValue(index);
    };

    const handleChange = (e, newValue) => {
        setValue(newValue);
    };

    function axisValue(condition) {
        var response = '';
        if (condition === 'rtl') {
            response = 'x-reverse';
        } else {
            response = 'x';
        }
        return response;
    }



    const handleStartEvolution = () => {
        history.push('/EvolutionRequest', {
            patient: selectedPatient,
            patientData: mockPatientData,
            codeMedicalCenters,
            medicalCenters,
            codeSpecialty,
            agendaMedical,
            selectedDay,
            closestTurn,
            lastTurnOfDay,
            centro,
            especialidad,
            businessHours
        });
    };


    const startEvolutionButton = () => {
        return (
            <div className={classes.newRequestEvolutionContainerButton}>
                <CustomButton
                    title={"Iniciar Evolucion"}
                    onClick={handleStartEvolution}
                    icon={<AddCircleIcon style={{ marginRight: "5px" }} />}
                    customClass={`${classes.customHeaderBtn} ${classes.lightLinearGradient} ${classes.newRequestEvolutionButton}`}
                />
            </div>
        );
    }


    const months = {
        Enero: 1,
        Febrero: 2,
        Marzo: 3,
        Abril: 4,
        Mayo: 5,
        Junio: 6,
        Julio: 7,
        Agosto: 8,
        Septiembre: 9,
        Octubre: 10,
        Noviembre: 11,
        Diciembre: 12,
    };






    return (
        <>
            <MenuProfile />
            <Box className={classes.txtTitleMedicalAgenda}>
                <Header title="Historia Clínica" />
            </Box>
            <Box className={classes.boxHeadermedicalCalendar}>
                <IconButton onClick={() => {
                    const { patient, ...restState } = history.location.state || {};
                    history.push('/PatientAgenda', restState);
                }}>
                    <ArrowBackIcon className={classes.iconFilter} />
                </IconButton>
            </Box>
            {startEvolutionButton()}
            <Box className={classes.contentBox}>
                <Box className={classes.medicalHistoryAccordion}>
                    <Accordion>
                        <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                            <Grid container alignItems="center" spacing={1}>
                                <Grid item>
                                    <AccountBoxIcon className={classes.menuButtonRight} />
                                </Grid>
                                <Grid item>
                                    <Typography >Datos del Afiliado</Typography>
                                </Grid>
                            </Grid>
                        </AccordionSummary>
                        <AccordionDetails>
                            <List>
                                <Fragment >
                                    <ListItem>
                                        <Grid container spacing={2}>
                                            <Grid item xs={12}>
                                                <Typography className={`${classes.textTitleMedicalHistory}`}>
                                                    PACIENTE
                                                </Typography>
                                                <Typography className={`${classes.textDescripctionMedicalHistory}`}>
                                                    {mockPatientData.datosAfiliado.nombre}
                                                </Typography>
                                            </Grid>
                                            {mockPatientData.datosAfiliado.dni && (
                                                <Grid item xs={12}>
                                                    <Typography className={`${classes.textTitleMedicalHistory}`}>
                                                        DNI | Credencial
                                                    </Typography>
                                                    <Typography className={`${classes.textDescripctionMedicalHistory}`}>
                                                        {mockPatientData.datosAfiliado.dni} | {mockPatientData.datosAfiliado.credencial.plan} - {mockPatientData.datosAfiliado.credencial.numero}
                                                    </Typography>
                                                </Grid>
                                            )}
                                            {mockPatientData.datosAfiliado.fechaNacimiento && (
                                                <Grid item xs={12}>
                                                    <Typography className={classes.textTitleMedicalHistory}>
                                                        Fecha de nacimiento
                                                    </Typography>
                                                    <Typography className={`${classes.textDescripctionMedicalHistory}`}>
                                                        {mockPatientData.datosAfiliado.fechaNacimiento}
                                                    </Typography>
                                                </Grid>
                                            )}
                                            {mockPatientData.datosAfiliado.sexo && (
                                                <Grid item xs={12}>
                                                    <Typography className={`${classes.textTitleMedicalHistory}`}>
                                                        Sexo
                                                    </Typography>
                                                    <Typography className={`${classes.textDescripctionMedicalHistory}`}>
                                                        {mockPatientData.datosAfiliado.sexo}
                                                    </Typography>
                                                </Grid>
                                            )}
                                        </Grid>
                                    </ListItem>
                                </Fragment>
                            </List>
                        </AccordionDetails>
                    </Accordion>

                    <Accordion >
                        <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                            <Grid container alignItems="center" spacing={1}>
                                <Grid item>
                                    <MenuBookIcon className={classes.menuButtonRight} />
                                </Grid>
                                <Grid item>
                                    <Typography >Enrolamientos</Typography>
                                </Grid>
                            </Grid>
                        </AccordionSummary>
                        <AccordionDetails>
                            <List>
                                {mockPatientData.enrolamientos.map((enrolamiento, index) => (
                                    <Fragment key={index}>
                                        <ListItem>
                                            <Grid container spacing={2}>
                                                <Grid item xs={12}>
                                                    <Typography className={`${classes.textTitleMedicalHistory}`}>
                                                        Programa: {enrolamiento.programa}
                                                    </Typography>
                                                </Grid>
                                                <Grid item xs={12}>
                                                    <Typography className={`${classes.textDescripctionMedicalHistory}`} >
                                                        Fecha desde: {enrolamiento.fechaDesde}
                                                        {enrolamiento.fechaBaja && ` - Fecha de baja: ${enrolamiento.fechaBaja}`}
                                                    </Typography>
                                                </Grid>
                                            </Grid>
                                        </ListItem>
                                        {index < mockPatientData.enrolamientos.length - 1 && <Divider />}
                                    </Fragment>
                                ))}
                            </List>
                        </AccordionDetails>
                    </Accordion>

                    {mockPatientData.alertas && mockPatientData.alertas.length > 0 && (
                        <Accordion >
                            <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                                <Grid container alignItems="center" spacing={1}>
                                    <Grid item>
                                        <WarningIcon className={classes.menuButtonRight} />
                                    </Grid>
                                    <Grid item>
                                        <Typography>Alertas/Alarmas</Typography>
                                    </Grid>
                                </Grid>
                            </AccordionSummary>
                            <AccordionDetails>
                                <List style={{ width: '100%' }}>
                                    {mockPatientData.alertas.map((alerta, index) => (
                                        <Fragment key={index}>
                                            <ListItem>
                                                <Grid container spacing={2}>
                                                    <Grid item xs={12}>
                                                        <Typography className={`${classes.textTitleMedicalHistory}`}>
                                                            Tipo de Alerta: {alerta.tipo}
                                                        </Typography>
                                                    </Grid>
                                                    <Grid item xs={12}>
                                                        <Typography className={`${classes.textDescripctionMedicalHistory}`}>
                                                            {alerta.observacion || '-'}
                                                        </Typography>
                                                    </Grid>
                                                </Grid>
                                            </ListItem>
                                            {index < mockPatientData.alertas.length - 1 && <Divider />}
                                        </Fragment>
                                    ))}
                                </List>
                            </AccordionDetails>
                        </Accordion>
                    )}
                </Box>
            </Box>
            <Box >
                <Box className={classes.authorizationHeader}>
                    <Tabs className={classes.authorizationTabs} value={value} onChange={handleChange} centered>
                        <Tab label="EVOLUCION" />
                        <Tab label="LABORATORIO" />
                        <Tab label="SIGNOS VITALES" />
                        <Tab label="ANTROPOMETRIA" />
                    </Tabs>
                </Box>
                <SwipeableViews
                    style={{ overflow: 'hidden' }}
                    axis={axisValue(theme.direction)}
                    index={value}
                    onChangeIndex={handleChangeIndex}
                >
                    <TabPanel value={value} index={0} dir={theme.direction}>
                        <TabEvolution
                            modelEvolutions={modelEvolutions}
                            selectedSpecialty={selectedSpecialty}
                            visibleItems={visibleItems}
                            loadingMore={loadingMore}
                            handleClickSeeMore={handleClickSeeMore}
                            months={months}
                            specialtiesByDoctor={specialtiesByDoctor}
                            isLoading={isLoading}
                            setSelectedSpecialty={setSelectedSpecialty}
                            loading={loading}
                            NotFound={NotFound}
                            isInitialLoad={isInitialLoad}
                            setIsInitialLoad={setIsInitialLoad}
                        />
                    </TabPanel>

                    <TabPanel value={value} index={1} dir={theme.direction}>
                        <TabLaboratorio
                            modelLaboratory={modelLaboratory}
                            isLoading={isLoading}
                            loading={loading}
                            NotFound={NotFound}
                            months={months}
                            handleClickSeeMore={handleClickSeeMore}
                        />
                    </TabPanel>

                    <TabPanel value={value} index={2} dir={theme.direction}>
                        <TabSignosVitales
                            modelVitalSigns={modelVitalSigns}
                            isLoading={isLoading}
                            loading={loading}
                            NotFound={NotFound}
                            months={months}
                            handleClickSeeMore={handleClickSeeMore}
                        />
                    </TabPanel>

                    <TabPanel value={value} index={3} dir={theme.direction}>
                        <TabAnthropometry
                            modelAnthropometry={modelAnthropometry}
                            isLoading={isLoading}
                            loading={loading}
                            NotFound={NotFound}
                            months={months}
                            handleClickSeeMore={handleClickSeeMore}
                        />
                    </TabPanel>
                </SwipeableViews>
            </Box>
            {showErrorMessageModal(msgError, openModalError, setOpenModalError, classes.borderWhite, classes.quickAccessIcon)}
            {openDetailModal && (
                <ModalEvolution
                    title={
                        <>
                            <Typography>Paciente</Typography>
                            {selectedEvolution?.paciente && (
                                <Typography variant="subtitle1">
                                    {selectedEvolution.paciente}
                                </Typography>
                            )}
                        </>
                    }
                    description={
                        value === 0 ? (
                            <DetailEvolution evolutionId={selectedEvolution?.id} />
                        ) : value === 1 ? (
                            <DetailLaboratory laboratoryId={selectedEvolution?.id} />
                        ) : value === 2 ? (
                            <DetailVitalSigns vitalSignsId={selectedEvolution?.id} />
                        ) : value === 3 ? (
                            <DetailAnthropometry anthropometryId={selectedEvolution?.id} />
                        ) : null
                    }
                    open={openDetailModal}
                    onClose={() => setOpenDetailModal(false)}
                />
            )}
        </>
    );
};
export default MedicalHistory;

